/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pb_Elevation_GainInputs */

const en_ui_pb_elevation_gain = /** @type {(inputs: Ui_Pb_Elevation_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevation Gain`)
};

const de_ui_pb_elevation_gain = /** @type {(inputs: Ui_Pb_Elevation_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhenmeter`)
};

/**
* | output |
* | --- |
* | "Elevation Gain" |
*
* @param {Ui_Pb_Elevation_GainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pb_elevation_gain = /** @type {((inputs?: Ui_Pb_Elevation_GainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pb_Elevation_GainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pb_elevation_gain(inputs)
	return de_ui_pb_elevation_gain(inputs)
});